import { render, staticRenderFns } from "./dictionary_item_dialog.vue?vue&type=template&id=7cc3c1d6"
import script from "./dictionary_item_dialog.vue?vue&type=script&lang=js"
export * from "./dictionary_item_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports